module.exports = __webpack_public_path__ + "img/down.cde10fea.svg";